/* eslint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TAddToComparisonRequest, TAddToComparisonModel, IMappers, TAddToComparisonResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IAddToComparisonResponse } from '../../entities/v1_add_to_comparison/AddToComparisonResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createAddToComparisonModel(parameters: TAddToComparisonRequest): TAddToComparisonModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'property-comparison',
    pathApi: '/v1/add-to-comparison/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IAddToComparisonOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TAddToComparisonRequest;
}

export async function fetchAddToComparison<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IAddToComparisonOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TAddToComparisonResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createAddToComparisonModel(parameters),
    config,
  )) as FetchResponse<TAddToComparisonResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IAddToComparisonResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TAddToComparisonResponse>;
}
